import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScrumboardService } from '../../scrumboard.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntil, single } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { MatDialog } from '@angular/material';
import { FormControl } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { NgxSpinnerService } from 'ngx-spinner';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  animations: fuseAnimations

})
export class ReportsComponent implements OnInit {

  // options
  views: any[] = [700, 400];
  showXAxisSprint: boolean = true;
  showYAxisSprint: boolean = true;
  gradientSprint: boolean = false;
  showLegendSprint: boolean = true;
  xAxisLabelSprint: boolean = true;
  showYAxisLabelSprint: string = 'Country';
  yAxisLabelSprint: boolean = true;
  showXAxisLabelSprint: string = 'Population';
  colorSprint = {
    domain: ['#5AA454', '#C7B42C', '#AAAAAA']
  };
  sprintData: any;
  // options: any;
  last15days = [];
  data: any;
  activities = [];
  totalProjectHours: any;
  remainingProjectHours: any;
  exceededHours: any;
  hoursConsumed = [];
  barGraphValues: any;
  estimatedData = [];
  completedData = [];
  sprintLabels = [];
  single: any[];
  multi: any[];
  finalResult = [];
  viewsprint: any[] = [700, 400];
  // options
  showxAxis = true;
  showyAxis = true;
  gradientsprint = false;
  showLegendsprint = true;
  showYAxisLabelsprint = true;
  xAxisLabelsprint = 'Sprint';
  showxAxisLabel = true;
  yAxisLabelsprint = 'Hours';
  public chartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          stepSize: 10,
          beginAtZero: true
        }
      }]
    }
  }

  public barChartOptions = {
    scales: {
      xAxes: [{
        ticks: {
          stepSize: 2,
          beginAtZero: true
        }
      }]
    }
  }
  chart = false;
  title = 'Angular Charts';
  view: any[];
  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Project Members';
  yAxisLabel = 'Count';
  showYAxisLabel = true;
  timeline = true;
  colorScheme = {
    domain: ['#9370DB', '#008080', '#999999', '#5AA454', '#808000', '#C7B42C']

  };
  //pie
  showLabels = true;
  barGaphData: any;
  linedata: any;
  boardList = [];
  stackedGaphData = [];
  employeesStackedGaphData = [];
  sprintList = [];
  sprintListDropDown = [];
  listOfSprints = [];
  nextSprint = [];
  board: any;
  private _unsubscribeAll: Subject<any>;
  projectId: any;
  projectName: any;
  sprintListCount: any;
  activeSprintCount: any;
  closedSprintCount: any;
  activeSprintLink: any;
  workItemsLink: any;
  sprintLink: any;
  sprintTasks = [];
  labelList = [];
  listOfTaskType = [];
  sprintStatus: any;
  boardId: any;
  backlogLink: string;
  taskCount: number;
  filteredOptions: Observable<any[]>;
  myControl = new FormControl();
  selectedSprint: any = { name: '', id: '' };
  cols: any[];
  sprintName: any;
  sprintSelected = '';
  activeSprintId: any;
  activeSprintName: any;
  activeSprintResults = [];
  statusOfSprint: any;
  selectedProject: any = { name: '', id: '' };
  options: { legend: { position: string; }; };
  showFilter: boolean;
  projectMembers = [];
  tabIndex: Number;
  backlogBoardListId: any;
  assigneeId: any;
  priorityValue = [];
  typeOfTaskValue = [];
  cities = [];
  selectedCity: any;
  backlogBoard: any[];
  matMenuSprintList = [];
  showchart = true;
  work: any;
  barGraphSprintData: any[];
  completedSum: Number;
  estimatedSum: Number;
  sprintTable = [];
  noData: boolean;
  yScaleMax = 0;
  ngxChartWidth = 1.7
  data1: any;
  barGraphTableData = [];
  totalCompletedHours: any;
  projectStartDate: any;
  projectEndDate: any;
  horizontalBar: any;
  sprintoptions: any;
  listOfSprintIds = [];
  selectedDate = new Date();
  membersIds = [];
  graphValue: any;
  workDetail = [];
  totalWorkHours = '';
  taskGaphData: { labels: any[]; datasets: { data: any[]; backgroundColor: string[]; hoverBackgroundColor: string[]; }[]; };
  backlogBoardId: any;

  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private _scrumboardService: ScrumboardService,
    private route: ActivatedRoute,
    private parseService: ParseService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private queryInterface: QueryInterface,
  ) {

    // Object.assign(this, { multi });

    this.horizontalBar = {
      labels: ['Arvina', 'Sivabalan', 'Avinash', 'Venkat', 'Sundar', 'Gnanapriya'],
      datasets: [
        {
          label: 'Work Hours',
          backgroundColor: '#9CCC65',
          borderColor: '#7CB342',
          data: [28, 48, 40, 19, 86, 27]
        }
      ]
    }

    this.sprintData = {
      labels: ['In-Progress', 'Completed', 'To-Do', 'QA-resady'],
      datasets: [
        {
          data: [300, 50, 100, 40],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ]

        }]

    };

    this.sprintoptions = {

      legend: {
        position: 'right'
      }
    };
    this.view = [innerWidth / this.ngxChartWidth, 400];

    // Object.assign(this, { single, multi })

    this.options = {
      legend: {
        position: 'top'
      }
    };

    this.cols = [
      { field: 'position', header: 'S.No' },
      { field: 'name', header: 'Sprint Name' },
      { field: 'estimatedHours', header: 'Estimated Hours' },
      { field: 'completedHours', header: 'Completed Hours' }
    ];

  }

  ngOnInit() {

    this.Last15Days();
    this.route.params.subscribe(async params => {
      this.projectId = params.boardId;
      this.projectName = params.boardUri;
      this.getBoardList();

      await this.selectTab(0);
      this.getProMembers(this.projectId);
      this.getActiveSprint();
      // this.getSprintHoursGraph();
      // this.getHoursConsumedTable();
    });

    this._scrumboardService.onBoardChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(board => {
        this.board = board;
      });

    this.getLabels();

  }

  async getActiveSprint() {
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.equalTo('status', 'Active');
    await query.find().then(results => {
      if (results.length > 0) {
        this.boardId = results[0].id;
        this.selectedSprint = {
          id: results[0].id,
          name: results[0].get('name') + ' - ' + results[0].get('status'),
          startDate: results[0].get('startDate'),
          endDate: results[0].get('endDate'),
          status: results[0].get('status'),
          createdAt: results[0].get('createdAt'),
        }
      }
    });
  }

  async getLabels() {
    this.labelList = [];
    await this._scrumboardService.getLabels().then(async res => {
      let result = res[0];
      this.labelList = result.get('taskType');
    });
  }

  async getSprintList() {
    this.sprintList = [];
    let resultArray = [];
    this.listOfSprintIds = [];

    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    await query.find().then(results => {
      results.forEach(async element => {

        this.listOfSprintIds.push(element.id);

        if (element.get('status') == 'New' || element.get('status') == 'Active' || element.get('status') == 'Closed') {
          resultArray.push({
            id: element.id,
            name: element.get('name') + ' - ' + element.get('status'),
            startDate: element.get('startDate'),
            endDate: element.get('endDate'),
            status: element.get('status'),
            createdAt: element.get('createdAt'),
          })
        }

        this.matMenuSprintList.push({
          id: element.id,
          name: element.get('name'),
          startDate: element.get('startDate'),
          endDate: element.get('endDate'),
          status: element.get('status'),
          createdAt: element.get('createdAt'),
        });

      });
      this.sprintListDropDown = resultArray.filter(x => x.name != 'Backlogs - New');

      this.backlogBoard = resultArray.filter(x => x.name == 'Backlogs - New');
      this.backlogBoard.forEach(res => {
        this.backlogBoardId = res.id;
      });

      this.sprintList = resultArray.sort((a, b) => {
        if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return -1; }
        if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return 1; }
      });

      let result = resultArray.filter(x => x.status != 'Active' && x.status != 'Closed' && x.name != 'Backlogs');
      this.listOfSprints = result.sort((a, b) => {
        if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return -1; }
        if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return 1; }
      });
      this.nextSprint = this.listOfSprints[0];
      let activeSprint = this.sprintList.filter(x => x.status == 'Active');
      activeSprint.forEach(res => {
        this.activeSprintId = res.id;
        this.activeSprintName = res.name;
        if (this.activeSprintId != undefined) {

        }
      });

      this.sprintListCount = this.sprintList.length;
    });
  }

  onResize(event) {
    this.view = [event.target.innerWidth / this.ngxChartWidth, 400];
  }

  getProMembers(projectId) {
    this.membersIds = [];
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('user');
    query.include('user.profile');
    query.equalTo('status', 'Assigned');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: projectId
    });
    query.limit(500000);
    query.find().then(results => {

      results.forEach(element => {
        this.membersIds.push(element.get('user').id);
        this.projectMembers.push({
          profileId: element.get('user').get('profile').id,
          userName: element.get('user').get('profile').get('firstName') + ' ' + element.get('user').get('profile').get('lastName'),
          userImage: element.get('user').get('profile').get('profileImageInfo').url,
        })
      });
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  async selectTab(index): Promise<void> {
    if (index == 0) {
      this.tabIndex = 0;
      await this.getSprintList();
      await this.getSprintBarGraph();
      await this.getSprintBarGraphTable();

    } else if (index == 1) {
      this.tabIndex = 1;

      this.getActivities();
      this.getWorkHours();

      // let queryInstance = this.parseService.instance.Object.extend('Tasks');
      // let query = new this.parseService.instance.Query(queryInstance);
      // query.include('Project');
      // query.equalTo('Project', {
      //   __type: 'Pointer',
      //   className: 'Project',
      //   objectId: this.projectId
      // });
      // query.notEqualTo('sprintId', {
      //   __type: 'Pointer',
      //   className: 'Sprint',
      //   objectId: this.backlogBoardId
      // });
      // query.limit(1000000);
      // await query.find().then(async results => {
      //   this.getTaskGraph(results);
      //    this.getEmpGraph(results);
      // });

    }
  }

  async getSprintBarGraph() {
    this.barGraphSprintData = [];
    this.sprintLabels = [];
    this.completedData = [];
    this.estimatedData = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.notEqualTo('name', 'Backlogs');
    query.equalTo('status', 'Closed');
    query.descending('createdAt');
    query.limit(5);
    await query.find().then(results => {

      results.forEach(element => {
        this.sprintLabels.push(element.get('name'));
        if (element.get('chartData').hours != undefined) {
          this.estimatedData.push(Number((element.get('chartData').hours.planned.total) / 3600).toFixed(2));
        }
        if (element.get('chartData').hours != undefined) {
          this.completedData.push(Number((element.get('chartData').hours.planned.completed) / 3600).toFixed(2));
        }
      });
      this.barGraphSprintData.push({ label: 'Estimated', backgroundColor: '#42A5F5', borderColor: '#1E88E5', data: this.estimatedData });
      this.barGraphSprintData.push({ label: 'Completed', backgroundColor: '#9CCC65', borderColor: '#7CB342', data: this.completedData });
      this.barGraphValues = {
        labels: this.sprintLabels,
        datasets: this.barGraphSprintData
      }
    });
  }

  async getSprintBarGraphTable() {
    this.barGraphTableData = [];
    this.sprintLabels = [];
    this.completedData = [];
    this.estimatedData = [];
    this.totalCompletedHours = 0;
    let i = 0;
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    query.notEqualTo('name', 'Backlogs');
    query.equalTo('status', 'Closed');
    query.descending('createdAt');
    await query.find().then(results => {
      results.forEach(element => {
        i = i + 1;
        this.barGraphTableData.push({
          position: i,
          name: element.get('name'),
          estimatedHours: this.secondsToHms(element.get('chartData').hours.planned.total),
          completedHours: this.secondsToHms(element.get('chartData').hours.planned.completed),
        });
        this.totalCompletedHours += (element.get('chartData').hours.planned.completed)

      });
    });
    this.getProjectInformation();
  }

  getProjectInformation() {
    let total = 0;
    this.remainingProjectHours = 0;
    this.exceededHours = 0;
    let queryInstance = this.parseService.instance.Object.extend('Project');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.projectId);
    query.find().then(results => {
      results[0].get('resourceDetails').details.forEach(element => {
        total += element.hours;
      });
      this.projectStartDate = results[0].get('projectInfo').projectStartDate;
      this.projectEndDate = results[0].get('projectInfo').actualCompletionDate;

      this.totalProjectHours = (total);
      let totalProjectHours = (this.totalProjectHours) * 60 * 60;
      let remainingProjectHours = (totalProjectHours - this.totalCompletedHours) < 0 ? 0 : (totalProjectHours - this.totalCompletedHours);
      let exceededHours = (totalProjectHours - this.totalCompletedHours) < 0 ? (totalProjectHours - this.totalCompletedHours) : 0

      this.remainingProjectHours = this.secondsToHms(this.remainingProjectHours)
      this.exceededHours = this.secondsToHms(exceededHours)

    });
  }

  async last15DaysTab(event) {
    this.selectedDate = this.last15days[event];
    this.getActivities();
    this.getWorkHours();
    // let queryInstance = this.parseService.instance.Object.extend('Tasks');
    // let query = new this.parseService.instance.Query(queryInstance);
    // query.include('Project');
    // query.equalTo('Project', {
    //   __type: 'Pointer',
    //   className: 'Project',
    //   objectId: this.projectId
    // });
    // query.notEqualTo('sprintId', {
    //   __type: 'Pointer',
    //   className: 'Sprint',
    //   objectId: this.backlogBoardId
    // });
    // query.limit(1000000);
    // await query.find().then(async results => {
    //   this.getTaskGraph(results);
    //   this.getEmpGraph(results);
    // });
  }

  async getByDate() {
    this.getActivities();
    this.getWorkHours();
    // let queryInstance = this.parseService.instance.Object.extend('Tasks');
    // let query = new this.parseService.instance.Query(queryInstance);
    // query.include('Project');
    // query.equalTo('Project', {
    //   __type: 'Pointer',
    //   className: 'Project',
    //   objectId: this.projectId
    // });
    // query.notEqualTo('sprintId', {
    //   __type: 'Pointer',
    //   className: 'Sprint',
    //   objectId: this.backlogBoardId
    // });
    // query.limit(1000000);
    // await query.find().then(async results => {
    // this.getTaskGraph(results);
    // this.getEmpGraph(results);
    // });
  }

  async getActivities() {
    this.activities = [];
    let result = [];
    let startend = this.startenddates(this.selectedDate ? this.selectedDate : new Date());

    let condition = [
      { condition: 'descending', field: 'createdAt' },
      { condition: 'limit', value: 5000 },
      { condition: 'include', value: 'updatedBy' },
      { condition: "equalTo", field: "moduleType", value: 'Sprint' },
      { condition: "containedIn", field: "updatedId", value: this.listOfSprintIds },
      { condition: "greaterThan", field: "createdAt", value: startend[0] },
      { condition: "lessThan", field: "createdAt", value: startend[1] },
    ]
    await this.queryInterface.executeQuery(this.parseService, 'ActivityCenter', condition).then(results => {
      results.forEach(async (element, index) => {
        let name;
        let queryInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', element.get('updatedId'));
        await query.find().then(res => {
          let sprintResult = res[0];
          name = sprintResult.get('name');
        });
        result.push({
          message: element.get('message'),
          updatedBy: element.get('updatedBy').get('firstName') + ' ' + element.get('updatedBy').get('lastName'),
          createdAt: element.get('createdAt'),
          updatedUserImage: element.get('updatedBy').get('profileImageInfo').url,
          sprintName: name
        });
        this.activities = result.sort((a, b) => {
          if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return -1; }
          if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return 1; }
        });
      });
    });
  }

  async getWorkHours() {
    let startend = this.startenddates(this.selectedDate ? this.selectedDate : new Date());
    let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(timeSheet);
    query.include('user');
    query.include('user.profile');
    query.include('user.profile.department');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.containedIn('user', this.membersIds);
    query.limit(1000000);
    await query.find().then(results => {
      let workDetails = [];
      this.membersIds.forEach(id => {
        let timeSheets = results.filter(x => x.get('user').id == id);
        let workHours = 0;
        let userName = '';
        if (timeSheets.length > 0) {
          timeSheets.forEach(tSheet => {
            let userProfile = tSheet.get('user').get('profile');
            userName = userProfile.get('firstName') + ' ' + userProfile.get('lastName');
            let totalAttendance = tSheet.get('totalAttendance');
            let workDatas = totalAttendance.project.filter(a => a.id == this.projectId);
            workDatas.forEach(workData => {
              workHours += workData.actualHours;
            });
          });
          if (workHours > 0) {
            workDetails.push({ position: 0, name: userName, id: id, workHours: workHours });
          }
        }
      });
      this.detailsToGraph(workDetails);
      this.workDetail = workDetails.sort(function (a, b) { return b.workHours - a.workHours });
      let totalHrs = 0;
      this.workDetail.forEach((element, index) => {
        element.position = index + 1;
        totalHrs += element.workHours;
        element.workHours = this.secondsToHms(Math.ceil(element.workHours / 1000));
      });
      this.totalWorkHours = this.secondsToHms(Math.ceil(totalHrs / 1000));
    });
  }

  detailsToGraph(workDetails) {
    let names = [];
    let workHrs = [];
    workDetails.forEach(element => {
      names.push(element.name);
      workHrs.push((Math.ceil(element.workHours / 1000) / 3600).toFixed(1));
    });
    this.graphValue = {
      labels: names,
      datasets: [
        {
          label: 'Work Hours',
          data: workHrs,
          backgroundColor: [
            '#9370DB',
            '#008080',
            '#999999',
            '#C7B42C',
            '#808000',
            '#5AA454',
            '#800080',
            '#FF00FF',
            '#000080',
            '#008080',
            '#00FFFF',
            '#FFC0CB',
            '#FF7F50',
            '#800000',
            '#333300'
          ],
          hoverBackgroundColor: [
            '#9370DB',
            '#008080',
            '#999999',
            '#C7B42C',
            '#808000',
            '#5AA454',
            '#800080',
            '#FF00FF',
            '#000080',
            '#008080',
            '#00FFFF',
            '#FFC0CB',
            '#FF7F50',
            '#800000',
            '#333300'
          ]
        }]
    };
  }

  async getTaskGraph(results) {
    this.spinner.show();
    let taskGraphResults = [];
    this.sprintTasks = [];
    let datePipe = new DatePipe('en-US');
    let selectedDate = datePipe.transform(new Date(this.selectedDate != undefined ? this.selectedDate : new Date()), 'dd MMM yyyy');

    let taskNames = [];
    let taskStatus = [];
    taskGraphResults = JSON.parse(JSON.stringify(results));
    this.boardList.forEach(result => {
      let res = taskGraphResults.filter(x => x.scrumboardList.name == result);

      if (res.length > 0) {
        if (result == 'Completed') {
          let completed = res.filter(x => datePipe.transform(x.taskUpdatedTime.completedDate, 'dd MMM yyyy') == selectedDate);
          taskNames.push(result);
          taskStatus.push(completed.length);
        }
        if (result == 'Ready for QA') {
          let readyForQA = res.filter(x => datePipe.transform(x.taskUpdatedTime.readyForQaDate, 'dd MMM yyyy') == selectedDate);
          taskNames.push(result);
          taskStatus.push(readyForQA.length);
        }
        if (result == 'Closed') {
          let closed = res.filter(x => datePipe.transform(x.taskUpdatedTime.closedDate, 'dd MMM yyyy') == selectedDate);
          taskNames.push(result);
          taskStatus.push(closed.length);
        }
      }
      // taskNames.push(result);
      // taskStatus.push(res.length);
    });
    this.taskGaphData = {
      labels: taskNames,
      datasets: [
        {
          data: taskStatus,
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ]
        }]
    }
    this.spinner.hide();
  }

  async getEmpGraph(taskResult) {
    let uniqueGraphData = [];
    this.spinner.show();
    let datePipe = new DatePipe('en-US');
    let selectedDate = datePipe.transform(new Date(this.selectedDate != undefined ? this.selectedDate : new Date()), 'dd MMM yyyy');
    this.employeesStackedGaphData = [];
    await this.projectMembers.forEach(async result => {

      var queryProfile = new this.parseService.instance.Object('Profile');
      queryProfile.id = result.profileId;

      let results = taskResult.filter(task => task.get('assigneesId').find(profileId => profileId == result.profileId));
      let series = [];
      this.boardList.forEach(innerresult => {

        let valueOfTask = results.filter(x => x.get('scrumboardList').get('name') == innerresult);
        if (valueOfTask.length > 0) {
          if (innerresult == 'Completed') {
            let completed = valueOfTask.filter(x => datePipe.transform(x.taskUpdatedTime.completedDate, 'dd MMM yyyy') == selectedDate);
            series.push({
              name: innerresult,
              value: completed.length
            });
          }
          if (innerresult == 'Ready for QA') {
            let readyForQA = valueOfTask.filter(x => datePipe.transform(x.taskUpdatedTime.readyForQaDate, 'dd MMM yyyy') == selectedDate);
            series.push({
              name: innerresult,
              value: readyForQA.length
            });
          }
          if (innerresult == 'Closed') {
            let closed = valueOfTask.filter(x => datePipe.transform(x.taskUpdatedTime.closedDate, 'dd MMM yyyy') == selectedDate);
            series.push({
              name: innerresult,
              value: closed.length
            });
          }
        }
        uniqueGraphData.push({
          name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
          series: series
        });
        this.employeesStackedGaphData = this.uniqBy(uniqueGraphData, JSON.stringify);
        this.spinner.hide();

      });
    });
  }

  async getEmployeesGraph(results) {
    this.spinner.show();
    let listOfTasks = [];
    let assigneeTask = [];
    this.employeesStackedGaphData = [];

    let uniqueTask = [];
    await results.forEach(async res => {
      let assignee = await this.getAssignees(res.get('assignee'));
      listOfTasks.push({
        id: res.id,
        title: res.get('title'),
        priority: res.get('taskType'),
        assignee: assignee,
        status: res.get('scrumboardList').get('name'),
        cardNumber: res.get('cardNumber'),
        typeOfTask: res.get('typeOfTask'),
        createdAt: res.get('createdAt'),
        taskRole: res.get('taskRole'),
        todoDateActivity: res.get('todoDateActivity'),
        inProgressDateActivity: res.get('inProgressDateActivity'),
        completedDateActivity: res.get('completedDateActivity'),
        closedDateActivity: res.get('closedDateActivity'),
        readyForQaDateActivity: res.get('readyForQaDateActivity'),
        reOpenDateActivity: res.get('reOpenDateActivity'),
        taskUpdatedTime: res.get('taskUpdatedTime'),
      });

      await this.projectMembers.forEach(async result => {
        await listOfTasks.forEach(innerresults => {
          let taskAssignees = innerresults.assignee.filter(x => x.profileId == result.profileId);

          if (taskAssignees.length > 0) {
            let test = {
              id: innerresults.id,
              title: innerresults.title,
              status: innerresults.status,
              cardNumber: innerresults.cardNumber,
              userName: result.userName,
              profileId: result.profileId,
              todoDateActivity: innerresults.todoDateActivity,
              inProgressDateActivity: innerresults.inProgressDateActivity,
              completedDateActivity: innerresults.completedDateActivity,
              closedDateActivity: innerresults.closedDateActivity,
              readyForQaDateActivity: innerresults.readyForQaDateActivity,
              reOpenDateActivity: innerresults.reOpenDateActivity,
              taskUpdatedTime: innerresults.taskUpdatedTime,
            }
            let itemIndex = assigneeTask.indexOf(test);
            if (itemIndex == -1) {
              assigneeTask.push(test);
            }
          }
          uniqueTask = this.uniqBy(assigneeTask, JSON.stringify);
        });
      });
      this.formEmployeesFinalValues(uniqueTask);
    });

  }

  formEmployeesFinalValues(result) {
    let uniqueGraphData = [];
    let yMax = []
    let nextMultipleOfFive = 0;
    let datePipe = new DatePipe('en-US');
    let selectedDate = datePipe.transform(new Date(this.selectedDate != undefined ? this.selectedDate : new Date()), 'dd MMM yyyy');

    this.projectMembers.forEach(userResult => {
      let series = [];
      let task = result.filter(y => y.profileId == userResult.profileId);
      this.boardList.forEach(innerresult => {
        let valueOfTask = task.filter(x => x.status == innerresult);

        if (valueOfTask.length > 0) {
          if (innerresult == 'Completed') {
            let completed = valueOfTask.filter(x => datePipe.transform(x.taskUpdatedTime.completedDate, 'dd MMM yyyy') == selectedDate);
            series.push({
              name: innerresult,
              value: completed.length
            });
          }
          if (innerresult == 'Ready for QA') {
            let readyForQA = valueOfTask.filter(x => datePipe.transform(x.taskUpdatedTime.readyForQaDate, 'dd MMM yyyy') == selectedDate);
            series.push({
              name: innerresult,
              value: readyForQA.length
            });
          }
          if (innerresult == 'Closed') {
            let closed = valueOfTask.filter(x => datePipe.transform(x.taskUpdatedTime.closedDate, 'dd MMM yyyy') == selectedDate);
            series.push({
              name: innerresult,
              value: closed.length
            });
          }
        }
        // let valueOfTask = task.filter(x => x.status == innerresult);
        // series.push({
        //   name: innerresult,
        //   value: valueOfTask.length
        // });
        uniqueGraphData.push({
          name: userResult.userName,
          series: series
        });

        this.employeesStackedGaphData = this.uniqBy(uniqueGraphData, JSON.stringify);
        this.spinner.hide();
      });
    });
  }

  async getRelations(result) {
    var relationResult = [];
    await result.query().each(function (obj) {
      relationResult.push(obj);
    });
    return relationResult;
  }

  async getAssignees(tasks) {
    let assignee = [];
    await tasks.query().each(innerElement => {
      assignee.push({
        name: innerElement.get('firstName') + ' ' + innerElement.get('lastName'),
        profileId: innerElement.id,
        profilePic: innerElement.get('profileImageInfo').url
      });
    });
    return assignee;
  }

  async getBoardList() {
    this.boardList = [];
    await this._scrumboardService.getLabels().then(async res => {
      let result = res[0];
      let listOfBoards = result.get('boardList');
      listOfBoards.forEach(element => {
        this.boardList.push(element.name);
      });
    });
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    // var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay;
  }

  selectWorkitems(value) {
    if (value.value == "Workitems by Hours") {
      this.chart = false;
    }
    if (value.value == "Workitems by sprint") {
      this.chart = true;
    }
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  Last15Days() {
    var result = [];
    for (var i = 0; i < 15; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i);
      result.push(d);
    }
    this.last15days = result;
  }

}

